import { useQuery } from 'react-query';
import {
  getRetailerProductByUrl,
  getRetailerStoreOpeningHours,
  getRetailerStores,
} from './heroApiClient';

export const useGetRetailerProductByUrl = ({
  retailerId,
  url,
}: {
  retailerId: string;
  url: string | undefined;
}) => {
  return useQuery(
    ['getRetailerProductByUrl', retailerId, url],
    () => (url ? getRetailerProductByUrl({ retailerId, url }) : undefined),
    { enabled: Boolean(url) },
  );
};

export const useGetRetailerStoreOpeningHours = (storeId?: string) => {
  return useQuery(
    ['getRetailerStoreOpeningHours', storeId],
    () => (storeId ? getRetailerStoreOpeningHours(storeId) : undefined),
    { suspense: true, enabled: Boolean(storeId), staleTime: Infinity },
  );
};

export const useGetRetailerStores = (retailerId: string) => {
  return useQuery(
    ['getRetailerStores', retailerId],
    () => getRetailerStores(retailerId),
    { enabled: Boolean(retailerId) },
  );
};
